module.exports = __webpack_public_path__ + "static/unlock-top-talent-in-india-d523c49eac7d0819cb681c9cd10ea2f1.png";